<template>
    <div v-if="showMenu" class="leftContainer">
        <div class="listItem" :class="getFilteredCurrentRoute() == menuItem.id.toLowerCase() ? 'selected':''"  v-for="(menuItem) in filteredMenu" :id="menuItem.id" :key="menuItem.id" @click="handleMenuClick(menuItem.id)">
            <div class="icon">
                <img alt="user" :src="require(`../assets/${menuItem.id}.svg`)">
            </div>
            <div class="name">{{menuItem.name}} </div>
        </div>
    </div>
</template>

<script>
import { MENU } from '@/constants';
import { useRouter } from 'vue-router';
import { mapGetters } from 'vuex';
import { getCookie } from '@/services/campaignService';
export default {
  name: 'LeftMenu',
  data() {
    return {
        menu: MENU
    }
  },
  methods: {
    handleMenuClick: function(id) {
        const role = getCookie("role");
        this.$router.replace(`${role === 'SUPERADMIN' || role === 'OPS' ? '/admin' : ''}/${id}`)
    }
  },
  props: {
    msg: String
  },
  setup() {
    const router = useRouter();

    const getCurrentRouteName = () => {
      return router.currentRoute.value.name;
    };

    const getFilteredCurrentRoute = () => {
      return router.currentRoute.value.name?.toLowerCase().replace("admin", "");
    };

    return { ...mapGetters(['getCurrentRouteName']), getCurrentRouteName, getFilteredCurrentRoute };
  },
  computed: {
    showMenu() {
      if(this.getCurrentRouteName() === 'StaticTnCPage' || this.getCurrentRouteName() === 'clickWrap'){
        return false;
      }else{
        return getCookie('token') && this.getCurrentRouteName() !== 'OAuth2HomePage' && 
          this.getCurrentRouteName() !== 'UnAuthorizedPage';
      }
    },
    filteredMenu() {
      const role = getCookie('role');
      if(!role && this.getCurrentRouteName() === 'Login') this.$router.go(0);
      return this.menu.filter(item =>  item.roles.includes(role))
    }
  },
}
</script>

<style scoped>
@font-face {
    font-family: "Inter-Regular" ;
    src: url('../assets/fonts/Inter-Regular.ttf');
}
    .leftContainer{
        width: 250px;
        display: flex;
        flex-direction: column;
        font-family: "Inter-Regular" ;
        /*position: fixed;*/
        left: 0px;
        top: 76px;
        background: #FFFFFF;
       
    }
    .listItem{
        display: flex;
        padding: 14px 0 14px 24px;
        cursor: pointer;
    }
    .name{
        margin-left: 20px;
        font-size: 14px;
    }
    .icon{
        width: 22px;
        height: 22px;
    }
    .selected {
      background-color: #E7EEFF;
      text-decoration: rgba(46, 49, 190, 1);
    }
</style>